import {
  ContentTypes,
  DocumentType,
} from 'modules/administratives/pages/CouncilMembers/components/CouncilMembersDocumentsCard';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { Document } from 'types';

type TemplateViewerBodyProps = {
  template: Document;
  contentType: DocumentType;
  isEmbedded?: boolean;
};

const getPageWrapperStyle = (
  contentType: DocumentType,
  isEmbedded: boolean
) => {
  if (contentType === ContentTypes.EMAIL) {
    return `w-100 p-0 bg-white  ${isEmbedded ? 'm-0' : 'shadow-lg m-5'}`;
  }
  if (isEmbedded) {
    return 'w-100 p-4 bg-white m-0';
  }
  return 'w-100 p-5 bg-white shadow-lg m-5';
};

const TemplateViewerBody: FC<TemplateViewerBodyProps> = ({
  template,
  contentType,
  isEmbedded = false,
}) => {
  const communication = template.editorModel;

  const pageWrapperStyle = getPageWrapperStyle(contentType, isEmbedded);

  const BodyContent = () => (
    <div className={pageWrapperStyle}>
      <div
        style={{
          whiteSpace: typeof communication === 'string' ? 'pre-line' : 'normal',
        }}
      >
        {communication || ''}
      </div>
    </div>
  );

  return (
    <>
      {isEmbedded ? (
        <BodyContent />
      ) : (
        <Modal.Body className="flex-1 relative p-0">
          <div className="absolute inset-0 bg-lighter">
            <div className="absolute left-0 right-0 top-0 bottom-0 d-flex items-center justify-center overflow-auto">
              <BodyContent />
            </div>
          </div>
        </Modal.Body>
      )}
    </>
  );
};

export default TemplateViewerBody;
